// @ts-check
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, CircularProgress, MenuItem } from '@material-ui/core';
import { createContractAction } from '../redux/actions/contract-actions';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtons: {
    marginTop: theme.spacing(0)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  }
}));

// const clients = [
//   {
//     id: 'UItXbYwpy9a6vf9e5aKf',
//     name: 'Checkers Group',
//     organization: 'checkers',
//     logo: 'http://cowabunga.co.za/static/img/logo.svg'
//   },
//   {
//     id: 'ktVwtgJiA7LslmvkFWwF',
//     name: 'RTT Logistics',
//     organization: 'rtt',
//     logo: 'http://cowabunga.co.za/static/img/logo.svg'
//   }
// ];

function CreateUserForm(props) {
  const classes = useStyles();
  const { error, loading } = useSelector((state) => state.contract);
  const { candidate_parties } = useSelector((state) => state.contracts);

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } = props;
  const candidates = candidate_parties.map((client) => ({ value: client.id, label: client.name }));

  /**
   * @param {string} name
   */
  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <TextField
        {...formikProps('promisee')}
        id="outlined-select-currency"
        select
        label="Candidate Party"
        variant="outlined"
        fullWidth={true}
      >
        {candidates.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      <div className={classes.formButtons}>
        {!loading && (
          <>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              fullWidth={true}
            >
              Create Contract
            </Button>
          </>
        )}

        {loading && (
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}

        {error && (
          <div>
            <span className={classes.errorText}>{error.message}</span>
          </div>
        )}
      </div>
    </form>
  );
}

const validationSchema = Yup.object({
  promisee: Yup.string('Select a candidate party').required('Candidate party is required')
});

export function CreateContractComponent({ client_id }) {
  const dispatch = useDispatch();

  const values = { promisee: '' };

  const submit = (data, actions) => {
    dispatch(createContractAction(client_id, data.promisee));

    actions.resetForm();
  };

  return (
    <Formik initialValues={values} validationSchema={validationSchema} onSubmit={submit}>
      {(props) => <CreateUserForm {...props} />}
    </Formik>
  );
}
